// extracted by mini-css-extract-plugin
export default {"compactCalendarContainer":"CalendarContainer-common-module__compactCalendarContainer___2FdAj","footerLayout":"CalendarContainer-common-module__footerLayout___beOoj"};